import _sfc_main from "./component-library330.mjs";
import "./component-library331.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "variant-selector-basic" }, [_vm._l(_vm.variants, function(variant, index) {
    return [_c(_setup.LinkButton, { key: index + variant.name, staticClass: "variant-selector-basic__item", class: { "variant-selector-basic__item--active": variant.active }, attrs: { "tag": "button", "type": "button", "title": variant.name, "transparent": "", "tabindex": "0", "small-padding": "" }, on: { "click": function($event) {
      return _vm.$emit("select-variant", { variant });
    } } }, [_vm._v(" " + _vm._s(variant.name) + " ")])];
  })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "ffaf5a46",
  null,
  null
);
const VariantSelectorBasic = __component__.exports;
export {
  VariantSelectorBasic as default
};
